import Vue from 'vue'
import App from './App.vue'
import Home from './components/Home.vue'
// import AppDetails from './components/AppDetails.vue'
import Journey from './components/Journey.vue'
import PageNotFound from './components/PageNotFound.vue'
import Router from 'vue-router'
import VuePageTransition from 'vue-page-transition'
import BootstrapVue from 'bootstrap-vue'
import VueMaterial from 'vue-material'
import 'vue-material/dist/vue-material.min.css'
import axios from 'axios'
import VueAxios from 'vue-axios'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import VueCookie from 'vue-cookie'
import QrcodeVue from 'qrcode.vue'
import * as firebase from 'firebase/app';
// import fb from '../firebaseConfig'
import 'firebase/messaging';
require('firebase/messaging')



const urlParameters = window.location.href;
if (urlParameters.includes("?")) {
  var qString ='?'+ urlParameters.split("?")[1];
}
const urlParams = new URLSearchParams(qString);
const myParam = urlParams.get('style');
require('./style/style.css');
require('./style/theme.css');

if (myParam !== null ){
  import('./style/'+ myParam + '.css');
}
else{
  import('./style/myChips.css');
 }

Vue.config.productionTip = false
Vue.use(BootstrapVue,VueAxios,axios,VueMaterial)
Vue.use(Router)
Vue.use(VuePageTransition)
Vue.use(VueCookie)
Vue.use(QrcodeVue);

const routes = [
  {
    path:'/:apiKey/:OS/:country/',
    name:'Home',
    query: { cVal:'', lang:'',totalCoins:'',advertising_id:'' },
    component:Home,
    meta: { transition: 'fade-in-right' },

  },
  // {
  //   path:'/:id/:apiKey/:OS/:country/', 
  //   component:AppDetails,
  // },
  {
    path:'/:apiKey/:OS/:country/journey/', 
    name:'Journey',
    // query: { cVal:'', lang:'',totalCoins:'',advertising_id:'' },
    component:Journey,
  },
  {
    path:'/:apiKey/WEB/:country/', 
    name:'WEB',
    component:Home,
    meta: { transition: 'fade-in-right' },
    query: {auto:'0'},
  },

  {
    path:'/:apiKey/ANDROID/:country/', 
    name:'ANDROID',
    component:Home,
    meta: { transition: 'fade-in-right' },
    query: {auto:'0' },
  },

  {
    path:'/:apiKey/IOS/:country/', 
    name:'IOS',
    component:Home,
    meta: { transition: 'fade-in-right' },
    query: {auto:'0'},
  },
  {
    path:'/:apiKey/',
    name:'notOs',
    query: { cVal:'', lang:'',totalCoins:'',advertising_id:'' },
    component:Home,
    meta: { transition: 'fade-in-right' },
  },
  {
    path:'/:apiKey/:OS',
    name:'Os',
    query: { cVal:'', lang:'',totalCoins:'',advertising_id:'' },
    component:Home,
    meta: { transition: 'fade-in-right' },
  },
  {
    path:'/',
    name:'Blank',
    component: PageNotFound
  },
]

const router = new Router({
  routes,

  // scrollBehavior (to, from, savedPosition) {
  /* eslint-disable no-console*/
  //   console.log(savedPosition)
  //   console.log(to)
  //   if (savedPosition) {
  //     return savedPosition
  //   } else {
  //     return { x: 0, y: 0 }
  //   }
  // }
})
let supportedLanguages = {"it": true, "en": true}
let lang = urlParams.get('lang') ? urlParams.get('lang') : navigator.language.slice(0,2);
if(lang && supportedLanguages[lang])
  Vue.prototype.$locale = require('./assets/locales/'+lang+'.json')
else
  Vue.prototype.$locale = require('./assets/locales/en.json')

// function hasQueryParams(route) {
//   return !!Object.keys(route.query).length
// }

// router.beforeEach((to, from, next) => {
//    if(!hasQueryParams(to) && hasQueryParams(from)){
//     next({name: to.name, query: from.query});
//   } else {
//     next()
//   }
// })

// window.nativeGoBack = function(){
//   // window.history.length > 1 ? router.go(-1) : window.Android.closeApp();
//   if (router.app._route.name !== 'Home'){
//     router.push({name:'Home', query: router.app._route.query});
//   }else if(window.Android){
//     window.Android.closeApp();
//   }
// }

Vue.directive('scroll', {
  inserted: function (el, binding) {
    let f = function (evt) {
      if (binding.value(evt, el)) {
        window.removeEventListener('scroll', f)
      }
    }
    window.addEventListener('scroll', f)
  }
})

const config = {
  apiKey: "AIzaSyCcl1xJrlLZ-Wx0GTWaqd9bc8VHZBJMMjc",
  authDomain: "mychips-b31fe.firebaseapp.com",
  databaseURL: "https://mychips-b31fe.firebaseio.com",
  projectId: "mychips-b31fe",
  storageBucket: "mychips-b31fe.appspot.com",
  messagingSenderId: "1076874884430",
  appId: "1:1076874884430:web:803e6a84ed97c5d18e5a1f",
  measurementId: "G-NTM3BMJNDX"
}

firebase.initializeApp(config)
// console.log(firebase);

if ('serviceWorker' in navigator) {
  navigator.serviceWorker.register('../firebase-messaging-sw.js', {scope: '/public/'})
  .then(function(reg) {
    // registration worked
    console.log('Registration succeeded. Scope is ' + reg.scope);
  }).catch(function(error) {
    // registration failed
    console.log('Registration failed with ' + error);
  });
}


console.log('SupportFCM:' + firebase.messaging.isSupported())


if(firebase.messaging.isSupported()){

    const messaging = firebase.messaging();
    messaging.usePublicVapidKey("BKw3RFjF6KjF22nHbO_7UbqFa8pibmf2kVLOpV6WO7INtr399PIesI6UL1skjEu8lYgmxMSkj7aGN1c4htU48b4");

    messaging.requestPermission()
    .then(function(){
      console.log('Have Permission');
      return messaging.getToken();
    })
    .then(function(token){
      console.log(token);
    })
    .catch(function(err){
      console.log(err);
    })

    navigator.serviceWorker.addEventListener("message", (message) => {
      var noteTitle = message.data.firebaseMessagingData.notification.title; 
      var noteOptions = {
        body: message.data.firebaseMessagingData.notification.body,
      };
      
      // console.log(message.data.firebaseMessagingData.notification)
      window.showNotification(noteTitle,noteOptions);
    });



    messaging.onMessage(payload =>{
      console.log('payload',payload);
      var noteTitle = payload.notification.title; 
      var noteOptions = {
        body: payload.notification.body,
      };

      // console.log("title ",noteTitle, " ", payload.notification.body);
          //var notification = //examples include this, seems not needed

      window.showNotification(noteTitle,noteOptions);
    })


  }

  // geoip.lookup(window.ip);
  // console.log("country: " + ip.name + " / " + ip.code);

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')

console.log(router.app._route.params.country)